(() => {
  const storageKey = 'gleanFoundingDeadline';
  const durationStorageKey = 'gleanFoundingDuration';
  const instances = new WeakMap();
  let memoryDeadline = 0;
  let memoryDuration = 0;

  const readStoredNumber = (key, fallback) => {
    try {
      return Number.parseInt(window.localStorage.getItem(key), 10);
    } catch {
      return fallback;
    }
  };

  const storeNumber = (key, value) => {
    try {
      window.localStorage.setItem(key, String(value));
    } catch {
      return;
    }
  };

  const initCountdown = (section) => {
    if (!(section instanceof HTMLElement) || instances.has(section)) return;

    const countdown = section.querySelector('[data-countdown]');
    const daysElement = section.querySelector('[data-countdown-days-value]');
    const hoursElement = section.querySelector('[data-countdown-hours-value]');
    const minutesElement = section.querySelector('[data-countdown-minutes-value]');
    if (!(countdown instanceof HTMLElement) || !daysElement || !hoursElement || !minutesElement) return;

    const configuredDays = Number.parseInt(section.dataset.countdownDays, 10);
    const durationDays = Number.isFinite(configuredDays) ? Math.min(Math.max(configuredDays, 1), 30) : 3;
    const durationMilliseconds = durationDays * 86400000;
    let deadline = readStoredNumber(storageKey, memoryDeadline);
    const storedDuration = readStoredNumber(durationStorageKey, memoryDuration);

    const resetDeadline = () => {
      deadline = Date.now() + durationMilliseconds;
      memoryDeadline = deadline;
      memoryDuration = durationMilliseconds;
      storeNumber(storageKey, deadline);
      storeNumber(durationStorageKey, durationMilliseconds);
    };

    const validateDeadline = () => {
      const remaining = deadline - Date.now();
      if (!Number.isFinite(deadline) || storedDuration !== durationMilliseconds || remaining <= 0 || remaining > durationMilliseconds + 60000) {
        resetDeadline();
      }
    };

    const tick = () => {
      let remaining = deadline - Date.now();
      if (remaining <= 0) {
        resetDeadline();
        remaining = durationMilliseconds;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      daysElement.textContent = String(days);
      hoursElement.textContent = String(hours).padStart(2, '0');
      minutesElement.textContent = String(minutes).padStart(2, '0');
      countdown.hidden = false;
    };

    validateDeadline();
    tick();
    const interval = window.setInterval(tick, 1000);
    instances.set(section, () => window.clearInterval(interval));
  };

  const init = (root = document) => {
    if (root instanceof HTMLElement && root.matches('[data-announcement-countdown]')) {
      initCountdown(root);
    }
    root.querySelectorAll?.('[data-announcement-countdown]').forEach(initCountdown);
  };

  const unload = (root) => {
    const sections = [];
    if (root instanceof HTMLElement && root.matches('[data-announcement-countdown]')) sections.push(root);
    root.querySelectorAll?.('[data-announcement-countdown]').forEach((section) => sections.push(section));
    sections.forEach((section) => {
      instances.get(section)?.();
      instances.delete(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
